<template>
  <div class="inventario">
    <component :is="inventario" />
  </div>
</template>

<script>
import NoExiste from '@/views/NoExiste.vue'

export default {
  name: 'Inventario',
  components: {
    NoExiste,
    'inventario-descargas': () =>
      import(
        /* webpackPrefetch: true */ '@/components/inventario/Descargas.vue'
      ),
    'inventario-recuentos': () =>
      import(
        /* webpackPrefetch: true */ '@/components/inventario/Recuentos.vue'
      ),
    'inventario-recuento': () =>
      import(/* webpackPrefetch: true */ '@/components/inventario/Recuento.vue')
  },
  computed: {
    inventario() {
      const acciones = ['descargas', 'recuentos', 'recuento']
      const accion = this.$route.params.accion.toLowerCase()
      if (acciones.includes(accion)) return `inventario-${accion}`
      return NoExiste
    }
  }
}
</script>
